import React from 'react';
import { AtSign, Copy, User, Users } from 'lucide-react';

/**
 * Секция с базовыми полями для email
 */
const BasicEmailSection = ({ formData, handleInputChange, errors }) => {
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-4 flex items-center">
        <AtSign className="w-5 h-5 mr-2 text-indigo-500" />
        Получатели письма
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Email получателя (обязательное поле) */}
        <div className="col-span-full">
          <label htmlFor="to" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <User className="w-4 h-4 mr-2 text-indigo-500" />
            Кому <span className="text-red-500 ml-1">*</span>
          </label>
          <input
            type="email"
            id="to"
            name="to"
            value={formData.to}
            onChange={handleInputChange}
            placeholder="mail@example.ru (или несколько через запятую)"
            className={`form-input w-full ${errors.to ? 'input-error' : ''}`}
            required
          />
          {errors.to && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.to}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Вы можете указать несколько адресов через запятую
          </p>
        </div>

        {/* Копия (CC) */}
        <div>
          <label htmlFor="cc" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-2 text-indigo-500" />
            Копия (CC)
          </label>
          <input
            type="text"
            id="cc"
            name="cc"
            value={formData.cc}
            onChange={handleInputChange}
            placeholder="mail@example.ru, mail2@example.ru"
            className={`form-input w-full ${errors.cc ? 'input-error' : ''}`}
          />
          {errors.cc && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.cc}
            </p>
          )}
        </div>

        {/* Скрытая копия (BCC) */}
        <div>
          <label htmlFor="bcc" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Copy className="w-4 h-4 mr-2 text-indigo-500" />
            Скрытая копия (BCC)
          </label>
          <input
            type="text"
            id="bcc"
            name="bcc"
            value={formData.bcc}
            onChange={handleInputChange}
            placeholder="mail@example.ru, mail2@example.ru"
            className={`form-input w-full ${errors.bcc ? 'input-error' : ''}`}
          />
          {errors.bcc && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.bcc}
            </p>
          )}
        </div>
        
        {/* Тема письма */}
        <div className="col-span-full">
          <label htmlFor="subject" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тема письма
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            value={formData.subject}
            onChange={handleInputChange}
            placeholder="Введите тему письма"
            className={`form-input w-full ${errors.subject ? 'input-error' : ''}`}
          />
          {errors.subject && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.subject}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicEmailSection;